// Checks if the submit button should be disabled based on form values
export function checkIsDisabledSubmitForm(form) {
  if (!form.rulesetId) return true;
  if (!form.yearMonth) return true;
  if (!form.brand) return true;
  if (!form.totalDaysOffPerHost) return true;

  if (form.isEventDay) {
    if (!form.peakDays || form.peakDays.some((day) => !day)) return true;
  } else {
    return false;
  }

  if (form.isAnyHostLeave) {
    if (!form.hostLeaves || !Array.isArray(form.hostLeaves)) return true;
    for (const leave of form.hostLeaves) {
      if (!leave.hostId) return true;
      if (!leave.leavesDate || leave.leavesDate.some((date) => !date)) return true;
    }
  } else {
    return false;
  }

  return false;
}
export const defaultValuesForm = {
  rulesetId: null,
  yearMonth: null,
  brand: null,
  totalDaysOffPerHost: null,
  isEventDay: false,
  customDoubleDates: [null, null],
  peakDays: [],
  isAnyHostLeave: false,
  hostLeaves: [],
};

export const nameOfDays = ['MIN', 'SEN', 'SEL', 'RAB', 'KAM', 'JUM', 'SAB'];

export const weeks = Array.from({ length: 7 }).map((_, index) => {
  return index + 1;
});

export const hours = Array.from({ length: 12 }).map((_, index) => {
  const hours = (index * 2).toString().padStart(2, '0');
  return {
    dateString: `${hours}:00`,
    hours: index * 2,
  };
});

export const backgroundColorMasterHost = ['#D7EECA', '#ECD3FF', '#B6EBF4', '#FFCDE4', '#E0FFB1', '#FFEA84', '#FFE6D8', '#CCE2FF', '#D6DEF8', '#FFC78C'];
